import { gql } from '@apollo/client';

export const GET_PROPOSAL_CONFIGURATION = gql`
  query ProposalSnapshot($id: ID) {
    proposal(id: $id) {
      proposalId
      submissionIdCreatedFrom
      settings {
        configuration {
          formData
          builder
          productsConfig
          commonProductsConfiguration
        }
      }
    }
  }
`;
